export const needsCloseCodes = (serviceTypeId) => {
    return ['SR', 'TC'].some(sc => serviceTypeId.startsWith(sc));
}

export const needsNoAccessReason = (serviceTypeId) => {
    return ['IN', 'RC'].some(sc => serviceTypeId.startsWith(sc));
}

export const isSrOrDi = (serviceTypeId) => {
    return ['SR', 'DI'].some(sc => serviceTypeId.startsWith(sc));
}

export const isSr = (serviceTypeId) => {
    return ['SR'].some(sc => serviceTypeId.startsWith(sc));
}



// WEBPACK FOOTER //
// ./src/utils/serviceTypeUtils.js